import * as React from 'react'
// libs
import { useQuery } from '@apollo/client/react'
// context
import { TableManagementContext } from 'containers/Search/layers/BL'
// graphql
import { OBJECT_ENTITIES_QUERY } from 'graphql/objects/queries'
// types
import { TRefetch } from 'types/refetch'
import { IObjectEntitiesResponse, IObjectEntity } from 'types/graphql'
import { NGetObjectEntities } from 'types/objects/helpers'
// utils
import get from 'lodash/get'

type Props = React.PropsWithChildren<unknown>

type QueryResponse = {
  objectEntities: IObjectEntitiesResponse
}

interface IContext {
  data: IObjectEntity[]
  refetch: TRefetch<QueryResponse, NGetObjectEntities.IVariables>
  isLoading: boolean
  totalCount: number
  isRefetching: boolean
}

export const ObjectsAndPropertiesPageContext = React.createContext<IContext>({} as any)

const ObjectsAndPropertiesPageAPI: React.FC<Props> = ({ children }) => {
  const { page, perPage } = React.useContext(TableManagementContext)

  const { data, networkStatus, refetch } = useQuery<QueryResponse>(OBJECT_ENTITIES_QUERY, {
    variables: {
      pagination: {
        pageSkip: page * perPage,
        pageTake: perPage
      }
    }
  })

  const objects: IObjectEntity[] = get(data, 'objectEntities.data', []).filter(({ apiName }) => apiName !== 'risks')

  const totalCount = get(data, 'objectEntities.pagination.totalCount')

  const value = {
    refetch,
    totalCount,
    data: objects,
    isLoading: networkStatus === 1,
    isRefetching: networkStatus === 2
  }

  return <ObjectsAndPropertiesPageContext.Provider value={value}>{children}</ObjectsAndPropertiesPageContext.Provider>
}

export default ObjectsAndPropertiesPageAPI
